module.exports = __webpack_public_path__ + "img/facebooklive.ea4a7f22.png";